export default {
  title: 'Odbiór paczki wniosków',
  type: 'object',
  properties: {
    packMdokId: {
      title: 'UID MDOK',
      type: 'integer'
    }
  }
};
